const createRequestPreset = (preset) => preset;
export const AI_REQUEST_PRESETS = [
    createRequestPreset({
        key: 'classification',
        description: 'Cheap, deterministic labeling and intent routing with compact structured outputs.',
        modelProfile: 'cheap',
        preferredProvider: null,
        temperature: 0,
        maxOutputTokens: 400,
        useStructuredOutputs: true,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['deterministic', 'router', 'cheap', 'structured']
    }),
    createRequestPreset({
        key: 'structuredExtraction',
        description: 'Strict JSON extraction from text with low-variance output and moderate output budget.',
        modelProfile: 'balanced',
        preferredProvider: null,
        temperature: 0,
        maxOutputTokens: 2_000,
        useStructuredOutputs: true,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['structured', 'json', 'extraction']
    }),
    createRequestPreset({
        key: 'visionExtraction',
        description: 'Image-aware extraction tasks with structured outputs and a modest output budget.',
        modelProfile: 'balanced',
        preferredProvider: null,
        temperature: 0,
        maxOutputTokens: 2_500,
        useStructuredOutputs: true,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['vision', 'structured', 'extraction']
    }),
    createRequestPreset({
        key: 'titleGeneration',
        description: 'Short-form title generation where low latency matters more than deep reasoning.',
        modelProfile: 'title',
        preferredProvider: null,
        temperature: 0.35,
        maxOutputTokens: 800,
        useStructuredOutputs: false,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['titles', 'copy', 'fast']
    }),
    createRequestPreset({
        key: 'creativeWriting',
        description: 'Long-form creative or motivational writing where quality matters more than low latency.',
        modelProfile: 'balanced',
        preferredProvider: null,
        temperature: null,
        maxOutputTokens: 6_000,
        useStructuredOutputs: false,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['creative', 'longform', 'copy']
    }),
    createRequestPreset({
        key: 'sqlGeneration',
        description: 'SQL authoring and query synthesis with deterministic output and stronger reasoning.',
        modelProfile: 'reasoning',
        preferredProvider: null,
        temperature: 0,
        maxOutputTokens: 4_000,
        useStructuredOutputs: false,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['sql', 'deterministic', 'reasoning']
    }),
    createRequestPreset({
        key: 'analysis',
        description: 'General analytical work that benefits from moderate reasoning and a generous text budget.',
        modelProfile: 'balanced',
        preferredProvider: null,
        temperature: 0.2,
        maxOutputTokens: 6_000,
        useStructuredOutputs: false,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['analysis', 'reasoning']
    }),
    createRequestPreset({
        key: 'agentChat',
        description: 'Interactive tool-using assistant turns with stronger reasoning and bounded output.',
        modelProfile: 'reasoning',
        preferredProvider: null,
        temperature: null,
        maxOutputTokens: 8_000,
        useStructuredOutputs: false,
        useToolCalling: true,
        parallelToolCalls: true,
        toolChoice: 'auto',
        useBuiltInWebSearch: false,
        builtInWebSearchContextSize: null,
        tags: ['agent', 'chat', 'tools']
    }),
    createRequestPreset({
        key: 'webSearch',
        description: 'Prompted web-search requests using a search-capable model and moderate output budget.',
        modelProfile: 'webSearch',
        preferredProvider: 'openai',
        temperature: null,
        maxOutputTokens: 6_000,
        useStructuredOutputs: false,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: true,
        builtInWebSearchContextSize: 'medium',
        tags: ['search', 'research', 'grounded']
    }),
    createRequestPreset({
        key: 'deepResearch',
        description: 'Long-running deep research with large output budgets and built-in search enabled by default.',
        modelProfile: 'deepResearch',
        preferredProvider: 'openai',
        temperature: null,
        maxOutputTokens: 100_000,
        useStructuredOutputs: false,
        useToolCalling: false,
        parallelToolCalls: null,
        toolChoice: null,
        useBuiltInWebSearch: true,
        builtInWebSearchContextSize: 'high',
        tags: ['deep-research', 'search', 'long-running']
    })
];
//# sourceMappingURL=aiRequestPresets.js.map